export const EN = {
    jobAdButton: "I'm interested",
    entrypointTitle: 'Have a question?',
    entrypointSubtitle: 'Use Stepstone AI to answer any questions you have about this role.',
    entrypointResumeButton: 'Resume conversation',
    entrypointResumeSubtitle: 'Ask anything about this job.',
    entrypointInputPlaceholder: 'Ask Anything',
    entrypointInputSuggestions: {
        location: 'Where is {company} located?',
        culture: 'What is the culture at {company}?',
        benefits: 'What benefits can I expect?',
        vacation: 'What is my vacation allowance?',
        inclusive: 'Is {company} inclusive?',
        careerDevelopment: 'What career development opportunities are there?',
    },
    entrypointSubHeading: 'Try asking...',
    ratePromptTitle: 'Rate the quality of this response.',
    ratePromptSubtitle: 'Give a thumbs up or thumbs down to improve this feature.',
    feedbackConfirm: 'Thank you for your feedback!',
    likeA11y: 'Good response',
    dislikeA11y: 'Bad response',
    dislikeFormTitle: "What's wrong with this answer?",
    dislikeFormOptions: {
        1: "Doesn't make sense",
        2: 'Inappropriate',
        3: "Doesn't answer the question",
        4: 'Not useful',
    },
    dislikeFormCancel: 'Cancel',
    dislikeFormSubmit: 'Submit',
    feedbackThankYouMessage: 'Thank you for your feedback!',
    feedbackLoadingMessage: 'Loading feedback options...',
    feedbackErrorMessage: 'Unable to load feedback options',
    csatPrompt: {
        boxHeadline: 'Is there anything else you would like to ask?',
        boxNoMoreQuestions: 'No, thanks',
        boxMoreQuestions: 'Yes, I have more questions',
        smileys: {
            feedbackHeadline: 'How satisfied were you with the conversation?',
            rate1: 'Strongly dissatisfied',
            rate2: 'Dissatisfied',
            rate3: 'Neutral',
            rate4: 'Satisfied',
            rate5: 'Strongly satisfied',
        },
    },
    stStAi: 'Stepstone AI',
    stepstoneAiBadge: 'Stepstone AI',
    under18: "For safety reasons, chat access is limited to users 18 and older. We've temporarily disabled this feature for your account. In the meantime, you can still browse job listings and company information on our platform.",
    errorAlert: "We're sorry but we are facing some issues while loading the chat. You can either continue to wait or try again.",
    errorTryAgain: 'Try again',
    headerLink: 'Questions about the job?',
    askAQuestionWidgetText: 'Ask a question',
    disclaimerAI: 'BETA: AI generated from job ad information',
    submitQuestion: 'Submit question',
    addAttachment: 'Add attachment',
    betaIntroMessage: '**Stepstone AI – Beta**\n\nStepstone AI is an AI-powered assistant. You are interacting with an automated system.\nResponses are generated automatically based on information provided by the employer and may be incomplete or inaccurate.',
    chatStorageNotice: 'This chat may be stored for a limited period for quality assurance and improvement of the AMA service in accordance with our privacy policy. Please do not share sensitive information.',
    chatStorageNoticeLinkText: 'privacy policy',
    chatStorageNoticeLinkUrl: 'https://www.stepstone.de/e-recruiting/rechtliches/datenschutzerklarung/',
    reportProblemLinkText: 'Report a problem',
    reportProblemLinkUrl: 'https://www.stepstone.de/e-recruiting/formular-zur-meldung-von-rechtswidrigen-inhalten/?reference={companyId}',
    welcomeQuestion: '**What do you want to know?**',
    errorHeading: '**Error**',
    technicalErrorMessage: 'Sorry, I encountered a technical error. Please try again later.',
    sessionLimitMessage: 'You exceeded the number of questions for the next **30 minutes**.',
    dailyLimitMessage: 'You exceeded the number of questions for today. You can continue asking questions tomorrow.',
    budgetLimitMessage: 'Stepstone AI is taking a short break and will be back at the start of next month.',
    processing: 'Processing...',
    chatTitle: 'Ask me anything about this company',
};
